export const BiddingTypesConstants = {
    FIXED: 'FIXED',
    STANDARD: 'STANDARD',
    TM: 'TM',
    FACTUAL: 'FACTUAL'
};
